"use strict";

var _regeneratorRuntime = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withLoadingMessage = void 0;

var antd_1 = require("antd");

function withLoadingMessage(loadingMessage, callback) {
  var _this = this;

  // @ts-ignore its complaining because U is not a promise, but it is...
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var hideLoading, result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              hideLoading = antd_1.message.loading(loadingMessage);
              _context.prev = 1;
              _context.next = 4;
              return callback.apply(void 0, args);

            case 4:
              result = _context.sent;
              hideLoading();
              return _context.abrupt("return", result);

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              hideLoading();
              throw _context.t0;

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9]]);
    }));
  };
}

exports.withLoadingMessage = withLoadingMessage;